module.exports = __webpack_public_path__ + "img/Anthony Daniels.eb39505b.jpg";